module.exports = __webpack_public_path__ + "img/HyperBio_title.0505582e.png";